import { useEffect } from 'react';

import { Navigate } from '@sorare/routing';

import { FOOTBALL_PLAY_PRO_ONBOARDING_CHOOSE_YOUR_LEVEL } from '@sorare/core/src/constants/__generated__/routes';
import { useGetSelectClubPath } from '@sorare/core/src/hooks/onboarding/useGetSelectClubPath';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { useFootballEvents } from '@sorare/gameplay/src/lib/events';

const ProOnboardingPage = () => {
  const track = useFootballEvents();
  const selectClubPath = useGetSelectClubPath();
  const {
    flags: { chooseYourLevelOnboardingActiveSports = [] },
  } = useFeatureFlags();
  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  const to = chooseYourLevelOnboardingActiveSports.includes('football')
    ? FOOTBALL_PLAY_PRO_ONBOARDING_CHOOSE_YOUR_LEVEL
    : selectClubPath;

  return <Navigate to={to} replace keepSearchParams />;
};

export default ProOnboardingPage;
